import API from './API.ts';
export default {
    //
    // GET
    //
    search(searchString) {
        return API.httpClient.get('search', {
            params: {
                input: searchString
            }
        });
    },
    getSearchResultPreviewData({ type, id }) {
        return API.httpClient.get('search/search-results-preview-data', {
            params: {
                type,
                id
            }
        });
    },
    searchCustomer(searchString) {
        return API.httpClient.get('search/customer', {
            params: {
                input: searchString
            }
        });
    },
    searchBookings({ searchString, checkedInBookingsOnly, searchContext, searchParam }) {
        // Implementerade searchContext och searchParam par:
        // searchContext => 'add-booking-to-group', searchParam => bookingGroup id
        return API.httpClient.get('search/booking', {
            params: {
                input: searchString,
                checked_in_bookings_only: checkedInBookingsOnly,
                search_context: searchContext,
                search_param: searchParam
            }
        });
    }
};
